import { render, staticRenderFns } from "./PersonalPropertyProductSearch.vue?vue&type=template&id=5a172b48"
import script from "./PersonalPropertyProductSearch.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertyProductSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports